import { DataService } from '../services/data_service';
import { ContentDetail } from '../entry-components/content-details/content-details.model';
import { EntryComponentConfig } from '../shared/types/common.model';

export class ContentDetailsClient {
  private dataService: DataService;

  constructor(internalConfig: EntryComponentConfig) {
    this.dataService = DataService.getInstance(internalConfig.baseUrl);
  }

  async getContentDetails(contentType: string, contentId: string, signal?: AbortSignal): Promise<ContentDetail> {
    const path = `/angie/content-details/item/${contentId}.json?content_type=${contentType}`;
    let response = await this.dataService.get(path, signal);
    response = Array.isArray(response) ? response[0] : response;
    return (response as { data: ContentDetail }).data;
  }
}
